import { format } from "date-fns"

export default function (value: any) {
  return value ? format(new Date(value), "dd-MM-y") : value
}
